// extracted by mini-css-extract-plugin
module.exports = {"container":"AsteriAd_container__wRyJL","hasDesktopAdhesion":"AsteriAd_hasDesktopAdhesion__sIoOw","close":"AsteriAd_close__Wut2q"};